<app-entreprises-commanditaires-update [entreprise]="entreprise!" ></app-entreprises-commanditaires-update>

